import React from "react";
import { withTranslation } from "react-i18next";
import { Badge } from "react-bootstrap";
import "./OnboardingStatus.scss";
import { STATUS } from "../../../core/constants/common";

function OnboardingStatus({ t, onBoardStatus }) {
  return (
    <div className="col-lg-5 p-2">
      <div className="card">
        <div className="card-body">
          <h6>{t("OnboardingStatus.label")}</h6>
          <div className="Riskpriority_status_count">
            <ul>
              {onBoardStatus.INVITED && (
                <li>
                  <span className="text-Invited">{STATUS["INVITED"]}</span>
                  <h4 className="m-0">{onBoardStatus.INVITED}</h4>
                </li>
              )}
              {onBoardStatus.ACCEPTED && (
                <li>
                  <span className="text-Accepted">{STATUS["ACCEPTED"]}</span>
                  <h4 className="m-0">{onBoardStatus.ACCEPTED}</h4>
                </li>
              )}
              {onBoardStatus.ONBOARDED && (
                <li>
                  <span className="text-Onboarded">{STATUS["ONBOARDED"]}</span>
                  <h4 className="m-0">{onBoardStatus.ONBOARDED}</h4>
                </li>
              )}
              {onBoardStatus.DRAFT && (
                <li>
                  <span className="text-Draft">{STATUS["DRAFT"]} </span>
                  <h4 className="m-0">{onBoardStatus.DRAFT}</h4>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withTranslation()(OnboardingStatus);
